<template>
  <v-card
    class="card-shadow border-radius-xl px-4 py-5"
    :class="$route.name == 'VrDefault' ? 'bg-gradient-default' : ''"
  >
    <div
      class="
        bg-gradient-info
        shadow-success
        border-radius-lg
        py-3
        pe-1
        mb-6
        mt-n12
      "
      style="position: relative;"
    >
      <v-overlay :value="loadingInvoices" absolute color="white" opacity="0.3">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-overlay>
      <div class="chart-area">
        <canvas
          :height="$route.name == 'VrDefault' ? '370' : '170'"
          :id="salesViewsID"
        >
        </canvas>
      </div>
    </div>
    <div class="d-flex align-center justify-space-between ms-2 mt-6 mb-0">
      <h6
        class="text-h6 font-weight-bold mb-0"
        :class="$route.name == 'VrDefault' ? 'text-white' : 'text-typo'"
      >
        Einnahmen {{ selectedYear || currentYear }}
      </h6>
      <h6
        class="text-h6 font-weight-bold mb-0 me-2"
        :class="$route.name == 'VrDefault' ? 'text-white' : 'text-info'"
      >
        {{ totalRevenue.toFixed(2) }} €
      </h6>
    </div>
  </v-card>
</template>
<script>
import Chart from "chart.js/auto";
import { mapGetters } from 'vuex';
import administrationData from "@/mixins/administrationMixin";

export default {
  name: "card-yearly-sales",
  mixins: [administrationData],
  data: function () {
    return {
      salesViewsID: "websiteViews",
      chartInstance: null,
    };
  },
  computed: {
    ...mapGetters(['loadingInvoices']),
    invoices() {
      return this.$store.getters.invoices;
    },
    monthlyData() {
      var array = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const targetYear = this.selectedYear || this.currentYear;

      this.invoices.forEach((element) => {
        if (element.state == "approved") {
          var date = new Date(element.create_time);
          if (targetYear == date.getFullYear()) {
            array[date.getMonth()] += parseFloat(
              element.transactions[0].amount.total
            );
          }
        }
      });

      return array;
    },
    totalRevenue() {
      return this.monthlyData.reduce((sum, value) => sum + value, 0);
    },
  },
  watch: {
    invoices() {
      // Destroy old chart instance before creating new one
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }
      
      this.chartInstance = new Chart(document.getElementById(this.salesViewsID).getContext("2d"), {
        type: "bar",
        data: {
          labels: [
            "Jan",
            "Feb",
            "Mär",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dez",
          ],
          datasets: [
            {
              label: "Einnahmen in €",
              tension: 0.4,
              borderWidth: 0,
              borderRadius: 4,
              borderSkipped: false,
              backgroundColor: "rgba(255, 255, 255, .8)",
              data: this.monthlyData,
              maxBarThickness: 6,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
          scales: {
            y: {
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
                color: "rgba(255, 255, 255, .2)",
              },
              ticks: {
                display: true,
                color: "#f8f9fa",
                padding: 10,
                font: {
                  size: 14,
                  weight: 300,
                  family: "Quicksand",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
            x: {
              grid: {
                drawBorder: false,
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                color: "#f8f9fa",
                padding: 10,
                font: {
                  size: 14,
                  weight: 300,
                  family: "Quicksand",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
          },
        },
      });
    },
  },
  beforeDestroy() {
    // Clean up chart instance on component destroy
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
  mounted() {
    // getAllInvoices is now called in Dashboard.vue to prevent duplicate calls
  },
  methods: {
    renderLineChart: function() {

    }
  }
};
</script>
